/**
 * The warning an operator must see before a late add commits. Wrapping is
 * required: the sentence names the round and the completion consequence, and
 * the toolbar hint it replaces does not wrap.
 */
export function OpenRoundCompletionNotice({
  message,
}: {
  message?: string | null;
}) {
  if (!message) return null;
  return (
    <p
      role="status"
      className="mulish m-0 max-w-prose text-left text-sm leading-relaxed text-text-primary"
    >
      {message}
    </p>
  );
}
